import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute(
  '/_layout/products/openclaw-custom-development/',
)({
  head: () => buildHead('/products/openclaw-custom-development'),
});
